import { VoltageOption } from "../global/constants/layers";

/** Build a CQL filter string from selected voltage values, e.g. "vn IN (69, 230)" */
export function buildCqlFilter(
  voltageOptions: VoltageOption[] | undefined,
  selectedValues: (number | string)[]
): string | undefined {
  if (!voltageOptions || selectedValues.length === 0) return undefined;
  const field = voltageOptions[0].field;
  if (selectedValues.length === 1) {
    const v = selectedValues[0];
    return typeof v === "string" ? `${field}='${v}'` : `${field}=${v}`;
  }
  const list = selectedValues
    .map((v) => (typeof v === "string" ? `'${v}'` : v))
    .join(",");
  return `${field} IN (${list})`;
}
